import React, { useEffect, useState } from 'react';
import { Zap, Menu, X, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'About Us',
    href: '#why-us'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Reviews',
    href: '#reviews'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#2d2d2d]/95 backdrop-blur-md border-b border-[#3a3a3a] py-3' : 'bg-transparent py-5'}`} data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex items-center justify-between" data-id="element-103">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-104">
            <div className="bg-[#FFD700] p-2 rounded-xl flex items-center justify-center" data-id="element-105">
              <Zap className="w-6 h-6 text-[#1f1f1f] fill-[#1f1f1f]" data-id="element-106" />
            </div>
            <span className="text-xl font-extrabold tracking-tight text-white uppercase italic" data-id="element-107">
              CABALLERO'S <br className="hidden sm:block" data-id="element-108" />
              <span className="text-white" data-id="element-109">ELECTRIC</span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-8" data-id="element-110">
            <div className="flex gap-6" data-id="element-111">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-gray-300 hover:text-white transition-colors" data-id="element-112">
                  {link.name}
                </a>)}
            </div>
            <div className="flex items-center gap-4" data-id="element-113">
              <a href="tel:+17025550123" className="text-sm font-medium text-white border border-gray-500 hover:border-white px-5 py-2.5 rounded-full transition-colors flex items-center gap-2" data-id="element-114">
                Call (702) 555-0123
              </a>
              <button className="bg-[#FFD700] hover:bg-[#e6c200] text-[#1f1f1f] px-6 py-2.5 rounded-full font-bold text-sm transition-colors flex items-center gap-2" data-id="element-115">
                Contact Us <ArrowRight className="w-4 h-4" data-id="element-116" />
              </button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden" data-id="element-117">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gray-300 hover:text-white p-2" data-id="element-118">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-119" /> : <Menu className="w-6 h-6" data-id="element-120" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-121">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-[#2d2d2d] border-b border-[#3a3a3a] overflow-hidden" data-id="element-122">
            <div className="px-4 pt-2 pb-6 space-y-4" data-id="element-123">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block text-base font-medium text-gray-300 hover:text-white py-2" data-id="element-124">
                  {link.name}
                </a>)}
              <div className="pt-4 border-t border-[#3a3a3a] flex flex-col gap-4" data-id="element-125">
                <a href="tel:+17025550123" className="w-full text-center text-base font-medium text-white border border-gray-500 px-5 py-3 rounded-full" data-id="element-126">
                  Call (702) 555-0123
                </a>
                <button className="w-full bg-[#FFD700] hover:bg-[#e6c200] text-[#1f1f1f] px-5 py-3 rounded-full font-bold text-base transition-colors flex items-center justify-center gap-2" data-id="element-127">
                  Contact Us <ArrowRight className="w-5 h-5" data-id="element-128" />
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}